import React, { useCallback, useEffect, useRef, useState } from "react";
import { Caption1, Input } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { preventNegativeAndEKeyPress } from "~/utils/utils";

export const WorkWeekHours = ({ days, onChange, onBlur, minValue, isValid, className, fieldRef }) => {
  const inputRefs = useRef([]);
  const [dayValues, setDayValues] = useState(days);

  useEffect(() => {
    setDayValues(days);
  }, [days]);

  const handleKeyDownOnInput = useCallback((e) => {
    preventNegativeAndEKeyPress(e);
  }, []);

  return (
    <div className={classNames("tw-flex tw-gap-2", className)}>
      {dayValues?.map((day, index) => {
        return (
          <div key={`${day.label}`}>
            <Caption1
              weight="bold"
              color={day.disabled ? "quaternary" : !day.isValid ? "alert" : "primary"}
            >
              {day.label}
            </Caption1>
            <Input
              className="tw-w-[54px] input-without-arrows"
              value={dayValues[index]?.value}
              data-testid={`test-${day.label}`}
              type="number"
              step="0.25"
              onBlur={() => {
                if (onBlur) {
                  onBlur(dayValues);
                }
              }}
              onKeyDown={handleKeyDownOnInput}
              onChange={(e) => {
                const value = e.target.value ? +e.target.value : "";
                let newState = [...dayValues].map((day, i) => {
                  if (i === index) {
                    return {
                      ...day,
                      value,
                      isValid: !day.disabled ? isValid(value) : true,
                    };
                  }

                  return day;
                });

                setDayValues(newState);

                if (onChange) {
                  onChange(newState);
                }
              }}
              ref={(node) => {
                inputRefs.current[index] = node;
                if (fieldRef) return (fieldRef.current[day.label] = node);
              }}
              min={minValue}
              max="24"
              disabled={day.disabled}
              invalid={!day.isValid}
            />
          </div>
        );
      })}
    </div>
  );
};

WorkWeekHours.propTypes = {
  days: PropTypes.array,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isValid: PropTypes.func,
  minValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  fieldRef: PropTypes.object,
};

WorkWeekHours.defaultProps = {
  minValue: 0,
};
